import HighlightText from '@common/components/highlighText';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const RacingItem = ({
  region, onSelectGame, search, sportType, alwaysOpen, id, routePrefix
}) => {
  const navigate = useNavigate();
  const [closed, setClosed] = useState(false);

  const dwopDownClick = () => {
    setClosed(!closed);
  };

  useEffect(() => setClosed(false), [alwaysOpen]);

  return (
    <div className={`region-container ${closed ? 'closed' : ''}`} key={region.id} onClick={!alwaysOpen && dwopDownClick}>
      <div className="region-name-container">
        <div className="regionName-Flag">
          <span
            className={`flag icon-${region.alias?.toLowerCase().replaceAll(' ', '')} flag`}
          />
          <span>{region.name}</span>
        </div>
        {!alwaysOpen && (
          <div className="arrow-section">
            {closed ? <i className="global-icon icon-thin-arrow-down" /> : <i className="global-icon icon-thin-arrow-up" />}
          </div>
        )}
        
      </div>
      <div className="competition-container">
        {region.competitions.map((comp) => (

          <div
            key={comp.id}
            className="competition"
            onClick={() => navigate(`${routePrefix}/racings/${sportType}/upComing/${region.alias}/${comp.id}/`)}
          >
            <div className="competition-name">
              <HighlightText
                text={comp.name}
                highlightPart={search}
              />
            </div>
            <div className="game-container">
              {(id !== 180 && id !== 153) && comp.games.filter((game) => !!game?.start_ts).map((game) => (
                <div
                  key={game.id}
                  className="game"
                  onClick={(e) => onSelectGame(
                    e,
                    routePrefix,
                    region.alias,
                    region.id,
                    comp.id,
                    game.id,
                  )}
                >
                  {moment.unix(game?.start_ts).format('HH:mm')}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RacingItem;
